<template>
  <div style="height: 1500px">
    <a-row :gutter="[24, 24]">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <a-row>
          <a-col :span="24">
            <div class="card-container">
              <a-tabs type="card">
                <a-tab-pane key="1" tab="Perturbation clusters">
                  <clusterNum />
                </a-tab-pane>
              </a-tabs>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import clusterNum from "./subcoms/clusterNum.vue";

export default {
  components: {
    clusterNum,
    //divCor
  },
  data() {
    return {};
  },
};
</script>
<style>
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 4px;
}
</style>
